export const facebook = 'https://web.facebook.com/frontierhomesofficial';
export const twitter = 'https://twitter.com/home';
export const instagram = 'https://www.instagram.com/officialfrontierhomes';
export const testimonialsOne = 'https://youtu.be/IFsRNJcXSqg';
export const testimonialsTwo = 'https://youtu.be/CSoDLsl2Wqc';
